import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

function formatErr(d) {
  if (!d) return "Something went wrong.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map(x => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export default function Register() {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { register } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await register(email, password, name);
      toast.success("Welcome to Lucid Shelf.");
      nav("/library");
    } catch (err) {
      setError(formatErr(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-[1360px] mx-auto px-6 lg:px-12 pt-16 pb-24 grid lg:grid-cols-12 gap-12">
      <div className="lg:col-span-6 lg:pr-16">
        <p className="eyebrow">Begin your shelf</p>
        <h1 className="font-serif-display text-5xl sm:text-6xl leading-none tracking-tighter mt-6">
          Join us,<br/><em className="italic text-[#B85C38]">slowly.</em>
        </h1>
        <p className="mt-6 text-[#5C5C5C] max-w-md leading-relaxed">
          Create an account to keep your books, receive quarterly essays, and reach the author with real questions.
        </p>
      </div>
      <div className="lg:col-span-6">
        <form onSubmit={submit} className="max-w-md bg-white border border-[#E5E2DC] p-8">
          <label className="eyebrow block">Your name</label>
          <input value={name} onChange={e=>setName(e.target.value)} data-testid="register-name"
            className="mt-2 w-full bg-[#F9F8F6] border border-[#E5E2DC] px-3 py-3 text-sm outline-none focus:border-[#2A3B32]" />

          <label className="eyebrow block mt-6">Email</label>
          <input value={email} onChange={e=>setEmail(e.target.value)} type="email" required data-testid="register-email"
            className="mt-2 w-full bg-[#F9F8F6] border border-[#E5E2DC] px-3 py-3 text-sm outline-none focus:border-[#2A3B32]" />

          <label className="eyebrow block mt-6">Password</label>
          <input value={password} onChange={e=>setPassword(e.target.value)} type="password" required minLength={6} data-testid="register-password"
            className="mt-2 w-full bg-[#F9F8F6] border border-[#E5E2DC] px-3 py-3 text-sm outline-none focus:border-[#2A3B32]" />

          {error && <p className="mt-4 text-sm text-[#B85C38]" data-testid="register-error">{error}</p>}

          <button type="submit" data-testid="register-submit" disabled={loading} className="btn-primary w-full justify-center mt-8">
            {loading ? "Creating…" : "Create account"}
          </button>
          <p className="mt-6 text-sm text-[#5C5C5C]">
            Already have an account? <Link to="/login" data-testid="link-login" className="link-underline text-[#1C1C1C]">Sign in</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
